import React, { useContext, useState } from 'react';
import { IdentityContext } from '../../context/identity';
import AccountInfoProvider from '../../context/account-info';
import { Link, navigate } from 'gatsby';
import { ApolloProvider } from "@apollo/client";
import { createApolloClient } from '../../../graphql/apollo/client';

const AuthWrapper = ({ children }) => {
    const { accountId, userId, isIdentified, refreshIdToken, token } = useContext(IdentityContext);
    const maybeAuthedClient = createApolloClient(token);
    return (
        <ApolloProvider client={maybeAuthedClient}>
            <AccountInfoProvider client={maybeAuthedClient} refreshIdToken={refreshIdToken} accountId={accountId} userId={userId}>
                {children}
            </AccountInfoProvider>
        </ApolloProvider>
    );

}

export default AuthWrapper;